var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showEmptyRatings || _vm.counts.averageValue > 0
      ? _c("div", { staticClass: "feedback-stars-average", class: _vm.size }, [
          _c(
            "div",
            { staticClass: "feedback-stars-background clearfix" },
            _vm._l(5, function(index) {
              return _c(
                "div",
                {
                  key: "star_background_" + index,
                  staticClass: "feedback-star"
                },
                [_c("i", { staticClass: "fa fa-star" })]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "feedback-stars-overlay-wrap",
              style: { width: _vm.fill }
            },
            [
              _c(
                "div",
                { staticClass: "feedback-stars-overlay clearfix" },
                _vm._l(5, function(index) {
                  return _c(
                    "div",
                    {
                      key: "star_overlay_" + index,
                      staticClass: "feedback-star"
                    },
                    [_c("i", { staticClass: "fa fa-star" })]
                  )
                }),
                0
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showRatingsAmount &&
    (_vm.showEmptyRatings || _vm.counts.averageValue > 0)
      ? _c("span", { class: _vm.size }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.scrollTo($event)
                }
              }
            },
            [_vm._v("(" + _vm._s(_vm.counts.ratingsCountTotal) + ")")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }